import React from 'react';

import { routes } from '@aline/routes';
import { Navigate } from 'react-router-dom';
import { Flag } from 'src/helpers/feature-flags';

import { GetStartedPage } from './GetStarted';

/**
 * Renders the onboarding experience only while it is enabled. Links and bookmarks to
 * /get-started land on chat when it is not, so the route never dead-ends.
 */
export function GetStartedRoute(): JSX.Element {
  if (!Flag.GET_STARTED_ONBOARDING) return <Navigate replace to={routes.ChatIndex} />;

  return <GetStartedPage />;
}
